import React from "react";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import ThreePillars from "../components/landing/ThreePillars";
import HowItWorks from "../components/landing/HowItWorks";
import TrustStrip from "../components/landing/TrustStrip";
import ForCarriers from "../components/landing/ForCarriers";
import ForCustomers from "../components/landing/ForCustomers";
import FAQ from "../components/landing/FAQ";
import AppDownload from "../components/landing/AppDownload";
import Footer from "../components/landing/Footer";
import SEOHead from "../components/SEOHead";
import homeJsonLd from "../data/homeJsonLd.json";
import { faqJsonLd } from "../lib/faq";

const HOME_JSON_LD = [homeJsonLd, faqJsonLd];

export default function LandingPage() {
  return (
    <div
      className="min-h-screen bg-cream-50 text-moss-900"
      data-testid="landing-page"
    >
      <SEOHead
        path="/"
        title="Binshare | Waste removal quotes from registered UK carriers"
        description="Snap a photo, post a job free and get fixed quotes from registered waste carriers. Rubbish removal, clearances and free item reuse."
        jsonLd={HOME_JSON_LD}
      />
      <Navbar />
      <main>
        <Hero />
        <ThreePillars />
        <HowItWorks />
        <TrustStrip />
        <ForCarriers />
        <ForCustomers />
        <FAQ />
        <AppDownload />
      </main>
      <Footer />
    </div>
  );
}
